export default () => {

  const productLinks = $('.data-product-scroll');
  const mq = window.matchMedia( "(max-width: 1150px)" );

  const callback = (e) => {
    e.preventDefault();

    const productLinkHref = $(e.currentTarget).attr('data-href');
    const elementScrollTo = $(productLinkHref);
    console.log(e.target, e.currentTarget);
    $('html, body').animate({
      scrollTop: elementScrollTo.offset().top - $(".appbar").height()
    }, 900);
 
  }

  const WidthChange = (mq) => {

    if (mq.matches) {
      productLinks.off('click', callback);
    } else {
      productLinks.on('click', callback);
    }
  }

  mq.addListener(WidthChange);
  WidthChange(mq);


};